import styled from "styled-components";

const FooterCopyRightContainer = styled.div`
  display: flex;
  align-items: center;
  border-top: 1px solid #666;
  margin-top: 30px;
  padding-top: 30px;

  @media (max-width: 575px) {
    margin-top: 20px;
    padding-top: 20px;
    flex-wrap: wrap;
  }
`;

export default FooterCopyRightContainer;